



































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SqlQueryRequestDto, SqlQueryResponseDto, AgentDto } from '@/shared/dtos/agents-admin';

@Component
export default class SqlQueryTab extends Vue {
    @Prop() public agents: AgentDto[] = [];
    @Prop() public sqlResult: SqlQueryResponseDto = new SqlQueryResponseDto();
    @Prop() public sqlHistory: SqlQueryRequestDto[] = [];
    @Prop() public loading: boolean = false;
    public formError: string = '';

    public queryRequest: SqlQueryRequestDto = new SqlQueryRequestDto({
        agent_id: '',
        installation_id: '',
        sql: '',
        max_rows: 200
    });

    public get agentOptions(): AgentDto[] {
        return this.agents.filter(a => !a.is_deleted && a.is_enabled);
    }

    public get agentSelectItems(): Array<{ text: string; value: string }> {
        return this.agentOptions.map(a => {
            const agentName = (a.agent_name || '').trim();
            const installation = (a.installation_id || '').trim();
            const namePart = agentName ? ` - ${agentName}` : '';
            const installationPart = installation ? ` (${installation})` : '';
            return {
                text: `${a.agent_id}${namePart}${installationPart}`,
                value: a.agent_id
            };
        });
    }

    public get canExecute(): boolean {
        const hasAgent = !!(this.queryRequest.agent_id || '').trim();
        const hasSql = !!(this.queryRequest.sql || '').trim();
        return hasAgent && hasSql && !this.loading;
    }

    public get tableHeaders(): any[] {
        if (this.sqlResult.columns.length === 0 && this.sqlResult.rows.length > 0) {
            return Object.keys(this.sqlResult.rows[0]).map(key => ({
                text: key,
                value: key,
                sortable: true
            }));
        }
        return this.sqlResult.columns.map(col => ({
            text: col,
            value: col,
            sortable: true
        }));
    }

    public async executeQueryForm() {
        this.formError = '';

        if (!this.queryRequest.agent_id || !(this.queryRequest.agent_id || '').trim()) {
            this.formError = 'Debes seleccionar un agente.';
            return;
        }

        if (!this.queryRequest.sql || !(this.queryRequest.sql || '').trim()) {
            this.formError = 'Debes escribir una consulta SQL.';
            return;
        }

        if (!this.isAllowedSql(this.queryRequest.sql)) {
            this.formError = 'Solo se permiten consultas de lectura o procedimientos almacenados: SELECT, SHOW, DESCRIBE, EXPLAIN, WITH, EXEC o EXECUTE.';
            return;
        }

        if (!this.queryRequest.max_rows || this.queryRequest.max_rows < 1) {
            this.queryRequest.max_rows = 1;
        }

        if (this.queryRequest.max_rows > 1000) {
            this.queryRequest.max_rows = 1000;
        }

        try {
            this.$emit('execute', this.queryRequest);
        } catch (error) {
            console.error('Error executing query:', error);
        }
    }

    public loadFromHistory(item: SqlQueryRequestDto) {
        this.queryRequest = new SqlQueryRequestDto(item);
        this.formError = '';
    }

    @Watch('queryRequest.agent_id')
    public onAgentChanged() {
        this.syncInstallationFromAgent();
    }

    public mounted() {
        this.syncInstallationFromAgent();
    }

    public truncate(text: string, length: number): string {
        return text.length > length ? text.substring(0, length) + '...' : text;
    }

    public formatDate(date: Date): string {
        return date.toLocaleTimeString('es-ES');
    }

    public exportResults() {
        if (this.sqlResult.rows.length === 0) return;

        const csv = this.convertToCSV(this.sqlResult.rows);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `sql-results-${Date.now()}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private convertToCSV(data: any[]): string {
        if (data.length === 0) return '';

        const headers = Object.keys(data[0]);
        const csv = [
            headers.map(h => `"${h}"`).join(','),
            ...data.map(row =>
                headers.map(h => {
                    const value = row[h];
                    if (value === null || value === undefined) return '""';
                    return `"${String(value).replace(/"/g, '""')}"`;
                }).join(',')
            )
        ];

        return csv.join('\n');
    }

    private isAllowedSql(sql: string): boolean {
        const normalized = (sql || '').trim().toUpperCase();
        if (!normalized) return false;
        return /^(SELECT|SHOW|DESCRIBE|EXPLAIN|WITH|EXEC|EXECUTE)\b/.test(normalized);
    }

    private syncInstallationFromAgent() {
        const selectedAgentId = this.queryRequest.agent_id || '';
        if (!selectedAgentId) return;

        const selected = this.agentOptions.find(a => a.agent_id === selectedAgentId);
        if (!selected) return;

        if (!this.queryRequest.installation_id && selected.installation_id) {
            this.queryRequest.installation_id = selected.installation_id;
        }
    }
}
